<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="3" class="mr-4">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              Docs
            </v-list-item-title>
            <v-list-item-subtitle>
              How to use IOT-Updater
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item-group v-model="activeTab" color="primary">
            <v-list-item
              v-for="item in items"
              :key="item.title"
              link
              :to="item.route"
              exact
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="12" sm="7">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      activeTab: `/docs`,
      items: [
        {
          id: 1,
          title: "What is ESP-Updater?",
          icon: "mdi-dots-hexagon",
          route: `/docs`,
        },
        {
          id: 2,
          title: "Setting up Firebase",
          icon: "mdi-dots-hexagon",
          route: `/docs/firebase`,
        },
        {
          id: 3,
          title: "Setting up our Device",
          icon: "mdi-dots-hexagon",
          route: `/docs/device`,
        },
      ],
    };
  },
};
</script>
